import config from "config/config"
import { ITranslations } from "@/types"
import tenantSettingsStore  from "stores/tenantSettings"

export function getTranslation(translations?: ITranslations | null, language?: string, fallbackLanguage?: string) {
    if (!translations) return ""
    if (language) return translations[language] || (fallbackLanguage ? translations[fallbackLanguage] : "") || translations[config.defaultLanguage] || ""
    const primaryLanguage = tenantSettingsStore.$tenantSettingsLanguages.getState()?.primaryLanguage.isoCode
    return translations[primaryLanguage || fallbackLanguage || config.defaultLanguage] || ""
}

export function prepareTranslations(translations: ITranslations, params: { multiline?: boolean } = {}) {
    const result: ITranslations = {}
    Object.keys(translations).forEach((key) => {
        if (typeof translations[key] !== "string") return
        // trim multiline values only at the end to allow any formatting with spaces and line wraps
        const trimmedValue = translations[key][params.multiline ? 'trimEnd' : 'trim']()
        if (trimmedValue) {
            result[key] = trimmedValue
        }
    })
    return result
}
